
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.TeamFoundation.Pipelines.Server.Plugins.Web
//----------------------------------------------------------


/// <amd-module name="Pipelines/Common/Library/Contracts/Constants" />
export module InputTypes {
    export var BOOL = "bool";
    export var FILEPATH = "filepath";
    export var INT = "int";
    export var MULTILINE = "multiline";
    export var PICKLIST = "picklist";
    export var RADIO = "radio";
    export var STRING = "string";
}

